module.exports = __webpack_public_path__ + "static/media/bakti-logo.8992bcff.svg";